/**
 * Internal dependencies
 */
const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  __experimental: true,
  name: "core/table-of-contents",
  title: "Table of Contents",
  category: "layout",
  description: "Summarize your post with a list of headings. Add HTML anchors to Heading blocks to link them here.",
  keywords: ["document outline", "summary"],
  textdomain: "default",
  attributes: {
    headings: {
      type: "array",
      items: {
        type: "object"
      }
    },
    onlyIncludeCurrentPage: {
      type: "boolean",
      "default": false
    }
  },
  supports: {
    html: false
  },
  example: {}
};
import edit from './edit';
import icon from './icon';
import save from './save';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  icon,
  edit,
  save
};
//# sourceMappingURL=index.js.map